import headerImgEn from "assets/images/v74/header-en.webp"
import infoImgEn from "assets/images/v74/info-en.png"

export const v74ConfigImages: Record<string, Record<string, string>> = {
  header: {
    en: headerImgEn,
  },
  info: {
    en: infoImgEn,
  },
}
